import React from 'react'
import { inject, observer } from 'mobx-react'

import Header from '../../MainHeader'
import Footer from '../../Footer'
import LandingPage from '~/components/traffic/lookup/landing'
import TicketLoader from '~/components/TicketLoader'
import { REQUEST_STATUSES } from '~/utilities/constants'

const Layout = props => {
  const scrollUp = () => {
    if (process.browser) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  let ComponentToRender = <div />
  switch (props.fetchingTicketsStatus) {
    case REQUEST_STATUSES.error: // Continue showing the loader while we push to '/lookup/{state}/no-result'
    case REQUEST_STATUSES.loading:
      scrollUp()
      ComponentToRender = <TicketLoader />
      break
    case REQUEST_STATUSES.complete:
    case REQUEST_STATUSES.init:
    default:
      scrollUp()
      ComponentToRender = <LandingPage />
      break
  }

  return (
    <>
      <Header isMobile={props.isMobile} noHamburger />
      <main>{ComponentToRender}</main>
      <Footer
        isStateAffiliatedWithWinitLaw={props.isStateAffiliatedWithWinitLaw}
      />
    </>
  )
}

export default inject(all => ({
  isMobile: all.store.ui.isMobile,
  fetchingTicketsStatus: all.store.trafficLookup.fetchingTicketsStatus,
  fetcherName: all.store.trafficLookup.fetcherName,
  isStateAffiliatedWithWinitLaw:
    all.store.trafficLookup.isStateAffiliatedWithWinitLaw
}))(observer(Layout))
